import { createI18n } from 'vue-i18n'

const messages = {
    ru: {
        nav: {
            cv: 'Резюме',
            project: 'Проекты',
            contact: 'Контакты',
            gallery: 'Галлерея',
        },
        cv: {
            full_name: 'Бакиров Роман',
            yo: 'лет',
            write_me_on_telegram: 'Связаться в Telegram',
        },
        project: {
            explore_in: 'Смотреть на',
        }
    },
    en: {
        nav: {
            cv: 'CV',
            project: 'Projects',
            contact: 'Contact',
            gallery: 'Gallery',
        },
        cv: {
            full_name: 'Roman Bakirov',
            yo: 'y.o.',
            write_me_on_telegram: 'Write me on Telegram',
        },
        project: {
            explore_in: 'Explore in',
            source: 'Исходный',
            code: 'Код',
        }
    },
}

const i18n = createI18n({
    locale: localStorage.getItem('language') ?? 'ru',
    fallbackLocale: 'en',
    messages,
    sync: true,
    globalInjection: true,
    legacy: false
})

export default i18n;
